export default function DiceLogo({ style }) {
  return (
    <div className="logo-container">
      <svg className="logo-svg" style={style} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle className="circle" cx="50" cy="50" r="48" />
        <line className="strings" x1="50" y1="-10" x2="35" y2="42" strokeWidth="2" />
        <line className="strings" x1="50" y1="-10" x2="61" y2="38" strokeWidth="2" />
        <g transform="translate(18, 42) rotate(-12)">
          <rect className="dice" width="28" height="28" rx="4" />
          <circle className="pips" cx="8" cy="8" r="2.5" />
          <circle className="pips" cx="14" cy="14" r="2.5" />
          <circle className="pips" cx="20" cy="20" r="2.5" />
        </g>
        <g transform="translate(50, 36) rotate(18)">
          <rect className="dice" width="32" height="32" rx="4" />
          <circle className="pips" cx="9" cy="9" r="2.5" />
          <circle className="pips" cx="23" cy="9" r="2.5" />
          <circle className="pips" cx="9" cy="23" r="2.5" />
          <circle className="pips" cx="23" cy="23" r="2.5" />
          <circle className="pips" cx="16" cy="16" r="2.5" />
        </g>
      </svg>
    </div>
  );
}
